var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgderOpsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 476.265,
    height: 73.345,
    viewBox: "0 0 476.265 73.345",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1197",
    "data-name": "Group 1197",
    transform: "translate(-559.077 -409.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1194",
    "data-name": "Group 1194",
    transform: "translate(647.812 434.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M600.56,419.166l-8.74,23.842h3.848l1.642-4.783h9.412l1.642,4.783h3.85l-8.739-23.842Zm-2.176,15.978,3.718-10.585,3.618,10.585Z",
    transform: "translate(-591.821 -418.966)",
    fill: "#ec4115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M608.726,433.327h5.089v1.336a5.4,5.4,0,0,1-1.206,3.753,5.068,5.068,0,0,1-3.883,1.675,4.761,4.761,0,0,1-3.518-1.442c-1.171-1.274-1.444-2.645-1.444-7.436s.274-6.127,1.444-7.4a4.786,4.786,0,0,1,3.518-1.474,4.87,4.87,0,0,1,5.024,4.152H617.4a8.379,8.379,0,0,0-8.672-7.4,8.53,8.53,0,0,0-6.265,2.545c-2.341,2.344-2.312,4.992-2.312,9.577s-.03,7.235,2.312,9.58a9.132,9.132,0,0,0,12.829-.171c1.572-1.672,2.144-3.648,2.144-6.729v-3.65h-8.707Z",
    transform: "translate(-577.581 -419.092)",
    fill: "#ec4115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M623.025,421.41a8.526,8.526,0,0,0-6.162-2.244h-8.371v23.842h8.371a8.523,8.523,0,0,0,6.162-2.238c2.577-2.58,2.409-6.4,2.409-9.848S625.6,423.987,623.025,421.41Zm-2.482,16.747a5.155,5.155,0,0,1-4.048,1.607h-4.387V422.415h4.387a5.145,5.145,0,0,1,4.048,1.607c1.241,1.371,1.276,3.618,1.276,6.9S621.784,436.783,620.543,438.157Z",
    transform: "translate(-563.315 -418.966)",
    fill: "#ec4115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M616.723,443.008h15.235v-3.245h-11.62V432.6h9.911v-3.215h-9.911v-6.967h11.62v-3.249H616.723Z",
    transform: "translate(-549.241 -418.966)",
    fill: "#ec4115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M640.817,426.133c0-4.054-2.878-6.967-7.4-6.967h-9.246v23.842h3.62V432.962h4.518l5.024,10.046h4.222l-5.5-10.547A6.26,6.26,0,0,0,640.817,426.133Zm-13.024,3.751v-7.469h5.355c2.412,0,4.052,1.406,4.052,3.751s-1.64,3.718-4.052,3.718Z",
    transform: "translate(-536.501 -418.966)",
    fill: "#ec4115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M643.484,419.092a8.523,8.523,0,0,0-6.26,2.545c-2.347,2.344-2.311,4.992-2.311,9.577s-.035,7.235,2.311,9.58a9.009,9.009,0,0,0,12.555,0c2.344-2.344,2.279-4.989,2.279-9.58s.065-7.233-2.279-9.577A8.594,8.594,0,0,0,643.484,419.092Zm3.547,19.525a5,5,0,0,1-7.095,0c-1.176-1.276-1.409-2.612-1.409-7.4s.233-6.127,1.409-7.4a5.005,5.005,0,0,1,7.095,0c1.173,1.271,1.406,2.61,1.406,7.4S648.205,437.341,647.032,438.617Z",
    transform: "translate(-518.137 -419.092)",
    fill: "#ec4115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M652.26,419.166h-9.043v23.842h3.618v-9.374h5.425c4.653,0,7.637-3.081,7.637-7.236S656.913,419.166,652.26,419.166Zm-.2,11.187h-5.222v-7.937h5.222c2.512,0,4.219,1.471,4.219,3.984S654.569,430.353,652.057,430.353Z",
    transform: "translate(-503.938 -418.966)",
    fill: "#ec4115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M660.829,429.672l-2.71-.4a5.312,5.312,0,0,1-2.68-1.108,2.817,2.817,0,0,1-.9-2.209c0-2.108,1.537-3.718,4.349-3.718a7.005,7.005,0,0,1,5.192,1.843l2.312-2.276a9.924,9.924,0,0,0-7.4-2.713c-4.957,0-7.97,2.845-7.97,7a5.94,5.94,0,0,0,1.74,4.553,8.215,8.215,0,0,0,4.523,1.913l2.813.4a4.161,4.161,0,0,1,2.615,1.008,3.211,3.211,0,0,1,.935,2.477c0,2.312-1.81,3.653-4.921,3.653a7.86,7.86,0,0,1-6.094-2.279l-2.415,2.379c2.279,2.309,4.859,3.149,8.441,3.149,4.989,0,8.572-2.612,8.572-7a6.256,6.256,0,0,0-1.94-4.891A7.941,7.941,0,0,0,660.829,429.672Z",
    transform: "translate(-491.978 -419.092)",
    fill: "#ec4115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M669.4,436.516l-5.491-17.35h-3.752L668,443.008h2.81l7.907-23.842h-3.821Z",
    transform: "translate(-474.968 -418.966)",
    fill: "#ec4115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M668.218,443.008h15.235v-3.245h-11.62V432.6h9.913v-3.215h-9.913v-6.967h11.62v-3.249H668.218Z",
    transform: "translate(-461.188 -418.966)",
    fill: "#ec4115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M683.919,433.327h5.092v1.336a5.385,5.385,0,0,1-1.209,3.753,5.06,5.06,0,0,1-3.883,1.675,4.764,4.764,0,0,1-3.517-1.442c-1.171-1.274-1.437-2.645-1.437-7.436s.266-6.127,1.437-7.4a4.789,4.789,0,0,1,3.517-1.474,4.868,4.868,0,0,1,5.024,4.152h3.65a8.386,8.386,0,0,0-8.674-7.4,8.528,8.528,0,0,0-6.262,2.545c-2.344,2.344-2.309,4.992-2.309,9.577s-.035,7.235,2.309,9.58a9.132,9.132,0,0,0,12.829-.171c1.575-1.672,2.144-3.648,2.144-6.729v-3.65h-8.71Z",
    transform: "translate(-448.996 -419.092)",
    fill: "#ec4115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M693.525,429.672l-2.71-.4a5.294,5.294,0,0,1-2.678-1.108,2.822,2.822,0,0,1-.908-2.209c0-2.108,1.539-3.718,4.352-3.718a7.005,7.005,0,0,1,5.192,1.843l2.312-2.276a9.921,9.921,0,0,0-7.4-2.713c-4.957,0-7.97,2.845-7.97,7a5.931,5.931,0,0,0,1.74,4.553,8.205,8.205,0,0,0,4.525,1.913l2.81.4a4.137,4.137,0,0,1,2.61,1.008,3.2,3.2,0,0,1,.943,2.477c0,2.312-1.81,3.653-4.924,3.653a7.859,7.859,0,0,1-6.1-2.279l-2.412,2.379c2.279,2.309,4.859,3.149,8.439,3.149,4.995,0,8.572-2.612,8.572-7a6.253,6.253,0,0,0-1.935-4.891A7.962,7.962,0,0,0,693.525,429.672Z",
    transform: "translate(-436.065 -419.092)",
    fill: "#ec4115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M690.98,443.008h15.235v-3.245H694.6V432.6h9.911v-3.215H694.6v-6.967h11.62v-3.249H690.98Z",
    transform: "translate(-422.266 -418.966)",
    fill: "#ec4115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M702.049,419.166h-3.618v23.842h15.106v-3.245H702.049Z",
    transform: "translate(-409.525 -418.966)",
    fill: "#ec4115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M715.363,429.672l-2.713-.4a5.334,5.334,0,0,1-2.677-1.108,2.821,2.821,0,0,1-.908-2.209c0-2.108,1.542-3.718,4.355-3.718a7,7,0,0,1,5.19,1.843l2.312-2.276a9.918,9.918,0,0,0-7.4-2.713c-4.959,0-7.973,2.845-7.973,7a5.932,5.932,0,0,0,1.74,4.553,8.225,8.225,0,0,0,4.523,1.913l2.813.4a4.13,4.13,0,0,1,2.609,1.008,3.2,3.2,0,0,1,.943,2.477c0,2.312-1.81,3.653-4.924,3.653a7.86,7.86,0,0,1-6.094-2.279l-2.415,2.379c2.279,2.309,4.859,3.149,8.444,3.149,4.989,0,8.572-2.612,8.572-7a6.257,6.257,0,0,0-1.94-4.891A7.969,7.969,0,0,0,715.363,429.672Z",
    transform: "translate(-398.728 -419.092)",
    fill: "#ec4115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M730.6,419.166h-4.425l-9.747,11.988V419.166h-3.615v23.842h3.615v-6.931l4.017-4.822,6.7,11.753H731.4l-8.537-14.5Z",
    transform: "translate(-384.928 -418.966)",
    fill: "#ec4115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M728.639,419.166,719.9,443.008h3.851l1.642-4.783H734.8l1.642,4.783h3.854l-8.742-23.842Zm-2.179,15.978,3.721-10.585,3.615,10.585Z",
    transform: "translate(-372.82 -418.966)",
    fill: "#ec4115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M737.712,419.166h-9.04v23.842h3.618v-9.374h5.423c4.656,0,7.634-3.081,7.634-7.236S742.368,419.166,737.712,419.166Zm-.2,11.187H732.29v-7.937h5.225c2.51,0,4.214,1.471,4.214,3.984S740.024,430.353,737.515,430.353Z",
    transform: "translate(-357.816 -418.966)",
    fill: "#ec4115"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1195",
    "data-name": "Group 1195",
    transform: "translate(559.077 409.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M568.961,462.5a14.619,14.619,0,0,0,20.221-.423l22.053-22.053a14.615,14.615,0,0,0,.358-20.286Z",
    transform: "translate(-542.175 -393.009)",
    fill: "#ec4115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M606.084,414.156a14.635,14.635,0,0,0-20.685,0l-22.051,22.053a14.591,14.591,0,0,0-4.157,12.176l61.578-19.541Z",
    transform: "translate(-559.077 -409.875)",
    fill: "#ec4115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M618.583,417.952,562.063,446.9l6.264,6.264L620.2,419.574Z",
    transform: "translate(-553.969 -396.065)",
    fill: "#ec4115"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgderOpsLogo);
export default __webpack_public_path__ + "static/media/agder_ops_logo.8da417d20f3ffa1a8d0bac6726ee8939.svg";
export { ForwardRef as ReactComponent };